import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { WorkoutPlayer } from "@/features/training/modules/workout-player/workout-player";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/training/workout")({
  loader: () => ({ crumb: m.workout_title() }),
  // The exercise picked on today's card opens first; without one, the first with a set left.
  validateSearch: z.object({ exercise: z.string().optional().catch(undefined) }),
  component: WorkoutRoute,
});

function WorkoutRoute() {
  const { exercise } = Route.useSearch();
  return <WorkoutPlayer exerciseId={exercise} />;
}
